import { UserV1 } from '@tovala/browser-apis-combinedapi'
import GivingMoneyIcon from 'components/common/icons/GivingMoneyIcon'
import MoneyIcon from 'components/common/icons/MoneyIcon'
import { ReactNode, useState } from 'react'
import { formatCentsToDollars } from 'utils/currency'
import { getTotalCreditsCents } from 'utils/user'
import RedeemGiftCardPromoModal from '../RedeemGiftCardPromoModal'

const AccountBalance = ({ user }: { user: UserV1 }) => {
  const [modalOpen, setModalOpen] = useState(false)
  return (
    <div>
      {modalOpen && (
        <RedeemGiftCardPromoModal
          onCloseModal={() => setModalOpen(false)}
          userID={user.id}
        />
      )}

      <div className="mb-6 grid grid-cols-2 gap-4 sm:gap-3">
        <AccountBalanceItem
          icon={<MoneyIcon />}
          title={
            <span>
              <span>
                {formatCentsToDollars(getTotalCreditsCents({ user }))}
              </span>
              <span className="md:block"> Tovala Cash</span>
            </span>
          }
        />

        <button onClick={() => setModalOpen(true)}>
          <AccountBalanceItem
            icon={<GivingMoneyIcon />}
            title={
              <span>
                <span className="md:hidden">Redeem </span>Gift Card/
                <br className="hidden md:block" />
                Promo
              </span>
            }
          />
        </button>
      </div>

      <p className="mb-10 text-k/16_125 md:text-k/14_120">
        Discounts and Tovala Cash are automatically applied towards your next
        order
      </p>
    </div>
  )
}

export default AccountBalance

const AccountBalanceItem = ({
  icon,
  title,
}: {
  icon: ReactNode
  title: ReactNode
}) => {
  return (
    <span className="flex flex-col items-center rounded-xl bg-white p-6 md:flex-row md:p-4">
      <span className="block size-12 text-orange-2 md:mr-2 md:size-10">
        {icon}
      </span>
      <h2 className="mb-4 text-k/20_125 font-semibold md:mb-0 md:text-left md:text-k/20_125 md:font-normal">
        {title}
      </h2>
    </span>
  )
}
